export default function getFileFormat(fileName: any) {
  const parts = fileName?.split(".");
  return parts?.length > 1 ? parts?.pop().toUpperCase() : null;
}
